<template>
  <div class="container">
    <!-- 头部导航栏 -->
    <HeaderRegion ref="headerForm" :isShowIndex="isShowIndex"></HeaderRegion>
      <div class="task-box">
        <div class="task-one" v-for="item in taskList" @click="taskDetails(item)">
          <img class="task-img" :src="baseImgUrl+item.squarePicture" alt="" />
          <div class="task-right">
            <div class="task-title">
              {{item.name}}
            </div>
            <div class="task-time">
              <div>活动时间：</div>
              <div>
                起 {{item.activityStartTime}}
              </div>
              <div>
                止 {{item.activityEndTime}}
              </div>
            </div>
          </div>
        </div>
      </div>


    <!-- 底部展示区域 -->
    <BottomRegion ref="bottomForm"></BottomRegion>
  </div>
</template>

<script>
import HeaderRegion from "../../components/headerRegion/headerRegion"; //引入头部导航栏
import BottomRegion from "../../components/bottomRegion/bottomRegion"; //引入底部展示
import {baseImgUrl} from "../../api/config"

export default {
  name: "home",
  components: {
    HeaderRegion,
    BottomRegion,
  },
  data() {
    return {
      headerForm: 0,
      isShowIndex: 1,
      id: "",
      taskList:[],
      baseImgUrl:baseImgUrl
    };
  },
  created() {
    this.id = this.$route.query.id;
    this.getData();
  },
  methods: {
    taskDetails(item){
      this.$router.push({
        path: "/task/taskDetail",
        query:{
          id:item.id
        }
      });
    },
    async getData() {
      try {
        let data = {
          id: this.id
        }
        const res = await this.$http.bannerDetails(data);
        if (res.code == 200) {
          if(res.result&&res.result.length>0){
            this.taskList = res.result;
          }else{
            this.taskList = [];
          }

        } else {
          this.$message(res.message);
        }
      } catch (e) {

        throw e
      }
    },
  },
};
</script>


<style scoped>
.task-box{
  width: 1186px;
  margin: 0 auto 0;
  padding-top: 80px;
  min-height: 90vh;
}
.task-one{
  width: 100%;
  background-color: white;
  display: flex;
  margin-top: 20px;
  border-radius: 10px;
  box-sizing:border-box;
  padding: 15px;
}
.task-img{
  width: 160px;
  height: 160px;
  flex-shrink: 0;
}
.task-right{
  margin-left: 30px;
}
.task-title{
  font-size: 16px;
  color: #3A3A3A;
  font-weight: bold;
}
.task-time{
  color: #9E9E9E;
  font-size: 14px;
  margin-top: 20px;
}

</style>



// WEBPACK FOOTER //
// src/pages/home/bannerTaskList.vue